module.exports = __webpack_public_path__ + "static/media/streamline-plump_web.8bdd7ae2.svg";